export class UrineCultureGrowth {

	OrganismCode: string;

	GrowthOption: string;

	ResistantFlag: string;

	OrganismName: string;

    AntibioticName: string;
    CultureReport: string;
    Intermediate: string;
    Resistant: string;
    Sensitive: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/lab/UrineCultureGrowth.ts